import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core'

/**
 * Adds a small padding on the right of a scroll container, but only while a classic
 * (space-taking) scrollbar is visible. Overlay scrollbars need no gap.
 */
@Directive({
  selector: '[appScrollbarGap]',
  standalone: false,
})
export class ScrollbarGapDirective implements AfterViewInit, OnDestroy {
  @Input() appScrollbarGap: number | string = 4

  private resizeObserver?: ResizeObserver
  private mutationObserver?: MutationObserver

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    const element = this.elementRef.nativeElement
    this.resizeObserver = new ResizeObserver(() => this.update())
    this.resizeObserver.observe(element)
    this.mutationObserver = new MutationObserver(() => this.observeChildren())
    this.mutationObserver.observe(element, { childList: true })
    this.observeChildren()
    this.update()
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect()
    this.mutationObserver?.disconnect()
  }

  private observeChildren(): void {
    Array.from(this.elementRef.nativeElement.children).forEach((child) =>
      this.resizeObserver?.observe(child),
    )
  }

  private update(): void {
    const element = this.elementRef.nativeElement
    const scrollbarWidth = element.offsetWidth - element.clientWidth
    const gap = Number(this.appScrollbarGap) || 4
    element.style.paddingRight = scrollbarWidth > 0 ? `${gap}px` : ''
  }
}
